module.exports = __webpack_public_path__ + "static/media/icon-open-sell-big.f913f6d7.svg";